import { FunctionComponent, useEffect } from 'react';

import { AppUtils } from '../../../../../core/AppUtils';
import { CursorManager } from '../../../../../core/navigation';
import {
    RootState,
    useTivoDispatch,
    useTivoSelector,
} from '../../../../../core/tivo/tivo-redux-wrapper';
import { disableGhostModeRecordingActivity } from '../../../../../store/settings/recordingactivity/recordingactivity.reducers';
import { Highlight } from '../../../../Highlight';

interface RecordingActivityHighlightProps {
    id?: string;
    cellType?: string;
}

export const RecordingActivityHighlight: FunctionComponent<RecordingActivityHighlightProps> = ({
    id,
    cellType,
}): JSX.Element => {
    const { verticalPosition, ghostMode } = useTivoSelector(
        (state: RootState) => state.recordingActivity,
    );

    const { isOverlayDialogActive: isAnyGuideOverlayVisible } = useTivoSelector(
        (state: RootState) => state.overlayDialog,
    );

    const { isSpinnerActive } = useTivoSelector((state: RootState) => state.spinner);

    const dispatch = useTivoDispatch();
    const isCursorAppeared = CursorManager.isCursorAppeared();

    useEffect(() => {
        if (!isCursorAppeared && ghostMode) {
            dispatch(disableGhostModeRecordingActivity());
        }
    }, [isCursorAppeared, ghostMode, dispatch]);

    const currentId = AppUtils.createHighlightId(0, verticalPosition);
    const isActive = id === currentId;
    const isGhostHighlightActive = ghostMode && isActive;
    const isHighlightVisible = !(isAnyGuideOverlayVisible || isSpinnerActive);

    return (
        <Highlight
            cellType={cellType}
            isActive={isActive}
            isGhostHighlightActive={isGhostHighlightActive}
            isHighlightVisible={isHighlightVisible || ghostMode}
            isPastGuideMode={false}
        />
    );
};
